<template>
  <div>
    <div id="login">
      <el-form id="form" v-model="form">
        <h3>請輸入帳號密碼</h3>
        <el-form-item>
          <el-input v-model="form.ID" placeholder="account">
            <i slot="prefix" class="fa fa-user-o"></i>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="form.PWD" type="password" placeholder="password">
            <i slot="prefix" class="fa fa-lock"></i>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" :disabled="locked">Login</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {accountLogin, initAccountData} from '../api/index'

export default {
  name: "Login",
  data() {
    return {
      form: {
        ID: '',
        PWD: '',
      },
      locked: false,
      style: {
        width: '40%',
        maxWidth: '200px'
      }
    }
  },
  methods: {
    onSubmit() {
      console.log('submit', this.form);
      this.locked = true
      accountLogin(this.form).then(data => {
        const {AUTH, TOKEN} = data
        this.$message.success('登錄成功')
        initAccountData(this.form.ID, AUTH, TOKEN)
        this.$router.push({name: 'Main'})
      }).catch(reason => {
        console.log(reason);
        this.$message.error('登錄失敗')
        this.locked = false
      })
    }
  }
}
</script>

<style scoped>
#login {
  display: flex;
  justify-content: center;
}

#form {
  width: 50%;
  max-width: 300px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
</style>
